import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AuthService,ResponseObject } from './auth.service';
import { ServiceBase } from './service.base';
import { environment } from 'src/environments/environment';
import { saveSystemSettingRequest, SystemSettings } from '../models/systemsetting.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SystemSettingService  extends ServiceBase {
  private api: string = '/SystemSetting';

  constructor(private http: HttpClient,
    authService: AuthService) {
      super(authService)
  }

  public fetchAllSystemSettings(): Observable<SystemSettings> {
    var httpOptions = this.RequestHeaders();

    const method: string = '/fetchSystemSettings';
    var url: string = environment.BASE_API_PATH + this.api + method;
    return this.http.get<SystemSettings>(url, httpOptions);
  }

  public saveSystemSettings(create: saveSystemSettingRequest): Observable<ResponseObject> {
    var httpOptions = this.RequestHeaders();

    const method: string = '/updateSystemSettings';
    const url: string = environment.BASE_API_PATH + this.api + method;
    return this.http.post<ResponseObject>(url,create, httpOptions);
  }

}
